export default __webpack_public_path__ + "static/media/polaroid_TheArtilleryTower.5b72750a.png";